(() => {
  'use strict';

  // One installation per document, including Shopify section remounts.
  if (window.__mimofitNewsletterConversionInstalled || !window.MutationObserver) return;
  window.__mimofitNewsletterConversionInstalled = true;

  const placementSelector = '[data-pushowl-form-id="162529"]';
  const formSelector = 'form.pushowl-embedded-form-container';
  const placements = new WeakMap();
  const text = (element) => element?.textContent.trim().replace(/\s+/g, ' ');

  function isSuccess(form) {
    return form && !form.querySelector('input, button[type="submit"]') &&
      text(form.querySelector('[id="title"]')) === "YOU'RE ALL SET!" &&
      text(form.querySelector('[id="subtitle"]')) === 'Thanks for signing up for our mailing list.';
  }

  function reportSuccess() {
    // Reuse the existing tag and consent runtime. Never create a tag/queue,
    // change consent, read contact values or replay a suppressed conversion.
    if (typeof window.gtag !== 'function') return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const send = (permission, name, parameters) => {
      try {
        if (typeof privacy[permission] === 'function' && privacy[permission]() === true) {
          window.gtag('event', name, parameters);
        }
      } catch (_) {
        // Tracking must never affect signup or the provider's success screen.
      }
    };
    send('marketingAllowed', 'conversion', { send_to: 'AW-18163418528/50-7CMaQ5pUdEKCL_9RD' });
    send('analyticsProcessingAllowed', 'sign_up', { send_to: 'G-X48VDH30GQ', method: 'brevo_newsletter' });
  }

  function inspect(placement, state) {
    if (!state.submitted || !placement.isConnected) return;
    const form = placement.querySelector(formSelector);
    if (isSuccess(form)) {
      // Consume before calling Google: duplicate mutations/callbacks cannot retry.
      state.submitted = false;
      reportSuccess();
    } else if (form?.querySelector('.pushowl-input-error') ||
               (form !== state.submitted && form?.querySelector('input'))) {
      state.submitted = false;
    }
  }

  function mount(placement) {
    if (placements.has(placement)) return;
    const state = { submitted: false };
    state.observer = new MutationObserver(() => inspect(placement, state));
    placements.set(placement, state);
    state.observer.observe(placement, { childList: true, subtree: true, characterData: true });
    // A success screen already present on mount is deliberately not a signup.
  }

  function visit(node, callback) {
    if (node.nodeType !== 1) return;
    if (node.matches(placementSelector)) callback(node);
    node.querySelectorAll(placementSelector).forEach(callback);
  }

  function unmount(placement) {
    const state = placements.get(placement);
    if (!state) return;
    state.observer.disconnect();
    placements.delete(placement);
  }

  // Capture the actual form submit before the provider prevents the default.
  // Clicks, invalid input, other forms and retired form 149234 cannot arm it.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!event.isTrusted || !(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;
    const placement = form.closest(placementSelector);
    if (!placement || !placement.isConnected || isSuccess(form) ||
        !form.querySelector('input[type="email"][name="email"]') || !form.checkValidity()) return;
    mount(placement);
    placements.get(placement).submitted = form;
  }, true);

  document.querySelectorAll(placementSelector).forEach(mount);
  new MutationObserver((records) => {
    // Discard in-flight attempts when a placement is removed, even if reinserted.
    records.forEach((record) => record.removedNodes.forEach((node) => visit(node, unmount)));
    records.forEach((record) => record.addedNodes.forEach((node) => visit(node, mount)));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
